export default __webpack_public_path__ + "static/media/3dFile.61f9fc27.svg";